module.exports = __webpack_public_path__ + "img/zhifubao.368302ee.png";